import { HereAddressItem, StructuredAddress } from "../types/address";

/**
 * Parse HERE Maps API response item into structured address format
 * Handles missing fields gracefully by defaulting to empty strings
 * 
 * @param item - HERE Maps API response item
 * @returns StructuredAddress object with parsed address fields
 */
export function parseHereAddress(item: HereAddressItem): StructuredAddress {
  const address = item.address || {};
  const position = item.position || { lat: 0, lng: 0 };

  // Fold the house number into the street line (HERE returns them separately),
  // e.g. houseNumber "521" + street "Poihipi Rd" -> "521 Poihipi Rd".
  const street = [address.houseNumber, address.street]
    .filter(Boolean)
    .join(" ")
    .trim();

  return {
    street,
    suburb: address.district || "",
    city: address.city || "",
    region: address.state || "",
    postcode: address.postalCode || "",
    country: address.countryName || "New Zealand",
    latitude: position.lat || 0,
    longitude: position.lng || 0,
    // Prefer the full one-line label (present for POIs and Autosuggest items);
    // fall back to the title for plain address results.
    fullAddress: address.label || item.title || "",
  };
}

